export const carEvaluation = [
  { key: "Accepted", value: "Accepted" },
  { key: "Non accepted", value: "Non accepted" },
]

export const states = [
  { key: "Active", value: "Active" },
  { key: "Inactive", value: "Inactive" },
]

export const productEnum = [
  { key: "Housing", value: "Housing" },
  { key: "Land purchase", value: "Land purchase" },
  { key: "Mortgage", value: "Mortgage" },
  { key: "Auto", value: "Auto" },
  { key: "Credit Card", value: "Credit Card" },
  { key: "Personal", value: "Personal" },
]

export const branch = [
  { key: "سحاب", value: "سحاب" },
  { key: "الرئيسي", value: "الرئيسي" },
  { key: "ماركا", value: "ماركا" },
  { key: "ش. عبدااله غوشه", value: "ش. عبدااله غوشه" },
  { key: "المفرق", value: "المفرق" },
  { key: "خلدا", value: "خلدا" },
  { key: "تاج مول", value: "تاج مول" },
  { key: "مأدبا", value: "مأدبا" },
  { key: "مكة مول", value: "مكة مول" },
  { key: "عبدون", value: "عبدون" },
  { key: "العقبه", value: "العقبه" },
  { key: "طبربور", value: "طبربور" },
  { key: "الشرق الاوسط", value: "الشرق الاوسط" },
  { key: "شارع مكه", value: "شارع مكه" },
  { key: "اربد", value: "اربد" },
  { key: "الصويفيه", value: "الصويفيه" },
  { key: "السلط", value: "السلط" },
  { key: "سيتي مول", value: "سيتي مول" },
  { key: "الزرقاء", value: "الزرقاء" },
  { key: "معان", value: "معان" },
  { key: "فرع باب المدينة مول", value: "فرع باب المدينة مول" },
  { key: "الكرك", value: "الكرك" },
  { key: "المنطقه الحره", value: "المنطقه الحره" },
  { key: "جرش", value: "جرش" },
  { key: "الطفيله", value: "الطفيله" },
  { key: "جبل عمان", value: "جبل عمان" },
  { key: "جبل الحسين", value: "جبل الحسين" },
  { key: "وادي صقرة", value: "وادي صقرة" },
  { key: "بوابه السلط", value: "بوابه السلط" },
  { key: "الزرقاء الجديده", value: "الزرقاء الجديده" },
  { key: "الرصيفه", value: "الرصيفه" },
  { key: "ارابيلا مول", value: "ارابيلا مول" },
  { key: "مؤته", value: "مؤته" },
  { key: "ش. وصفي التل", value: "ش. وصفي التل" },
  { key: "جامعه البلقاء", value: "جامعه البلقاء" },
  { key: "الهاشمي الشمالي", value: "الهاشمي الشمالي" },
  { key: "مرج الحمام", value: "مرج الحمام" },
  { key: "الجبيهه", value: "الجبيهه" },
  { key: "شارع الحريه", value: "شارع الحريه" },
  { key: "الرمثا", value: "الرمثا" },
  { key: "البيادر", value: "البيادر" },
  { key: "الفحيص", value: "الفحيص" },
  { key: "دير علا", value: "دير علا" },
  { key: "ضاحيه الياسمين", value: "ضاحيه الياسمين" },
  { key: "بوليفارد العبدلي", value: "بوليفارد العبدلي" },
  { key: "سوق ام اذينه", value: "سوق ام اذينه" },
  { key: "وسط البلد", value: "وسط البلد" },
  { key: "ش. ابن خلدون", value: "ش. ابن خلدون" },
  { key: "الشركات الكبرى", value: "الشركات الكبرى" },
]

export const familyStatus = [
  { key: "single", value: "Single" },
  { key: "married", value: "Married" },
  { key: "divorced", value: "Divorced" },
  { key: "widowed", value: "Widowed" },
  { key: "seperated", value: "Seperated" },
  { key: "other", value: "Other" },
  { key: "nan", value: "N/A" },
]

export const familyStatuses = [
  { key: "single", value: "Single" },
  { key: "married", value: "Married" },
  { key: "widowed", value: "Widowed" },
  { key: "nan", value: "N/A" },
  { key: "seperated", value: "Separated" },
  { key: "divorced", value: "Divorced" },
  { key: "other", value: "Other" },
]

export const genders = [
  { key: "male", value: "Male" },
  { key: "female", value: "Female" },
]

export const employmentSpheres = [
  { key: "retired", value: "Retired" },
  { key: "pub-sect-emp", value: "Public sect emp" },
  { key: "priv-sect-emp", value: "Private sect emp" },
  { key: "unemployed", value: "Unemployed" },
  { key: "business-owner", value: "Business owner" },
  { key: "jab-employee", value: "Jab employee" },
  { key: "int-orgs", value: "Interorg" },
  { key: "self-employed", value: "Self employed" },
  { key: "resigned", value: "Resigned" },
  { key: "banker", value: "Banker" },
  { key: "prof-self-employed", value: "Prof self employed" },
  { key: "lawyer", value: "Lawyer" },
  { key: "unions", value: "Unions" },
  { key: "other", value: "Other" },
  { key: "nan", value: "N/A" },
]

export const yesNoOptions = [
  { key: "Yes", value: "Yes" },
  { key: "No", value: "No" },
]

export const yesNoCoBorrower = [
  { key: "yes", value: "Yes" },
  { key: "no", value: "No" },
]

export const loanType = [
  { key: "New", value: "New" },
  { key: "Buyout", value: "Buyout" },
]

export const status = [
  { key: "approve", value: "Approve" },
  { key: "reject", value: "Reject" },
]

export const employmentLevel = [
  { key: "manager", value: "Manager" },
  { key: "nan", value: "N/A" },
  { key: "other", value: "Other" },
  { key: "lieut.2nd", value: "Lieutenant 2nd" },
  { key: "captain", value: "Captain" },
  { key: "employee", value: "Employee" },
  { key: "sargent", value: "Sergeant" },
  { key: "teacher", value: "Teacher" },
  { key: "gen.mgr", value: "General Manager" },
  { key: "asst.mgr", value: "Assistant Manager" },
  { key: "sec.head", value: "Section Head" },
  { key: "lance.corp", value: "Lance Corporal" },
  { key: "driver", value: "Driver" },
  { key: "admin.spec", value: "Administrative Specialist" },
  { key: "soldier", value: "Soldier" },
  { key: "sarg.1st", value: "Sergeant 1st Class" },
  { key: "admin.emp", value: "Administrative Employee" },
  { key: "office.mgr", value: "Office Manager" },
  { key: "supervisor", value: "Supervisor" },
  { key: "worker", value: "Worker" },
  { key: "police", value: "Police Officer" },
  { key: "nurs.asst", value: "Nursing Assistant" },
  { key: "guard", value: "Guard" },
  { key: "corporal", value: "Corporal" },
  { key: "military", value: "Military" },
  { key: "gm", value: "General Manager" },
  { key: "exec.mgr", value: "Executive Manager" },
  { key: "sec.super", value: "Section Supervisor" },
  { key: "mgr.asst", value: "Manager Assistant" },
  { key: "lieut.1st", value: "Lieutenant 1st" },
  { key: "tea.boy", value: "Tea Boy" },
  { key: "private", value: "Private" },
  { key: "asst.offr", value: "Assistant Officer" },
  { key: "admin.mgr", value: "Administrative Manager" },
  { key: "self.empl", value: "Self-Employed" },
  { key: "ceo", value: "CEO" },
  { key: "sold.1st", value: "Soldier 1st Class" },
  { key: "lieutenant", value: "Lieutenant" },
  { key: "first.off", value: "First Officer" },
  { key: "lan.cor1st", value: "Lance Corporal 1st" },
]

export const educations = [
  { key: "bachelor", value: "Bachelor" },
  { key: "high.diploma", value: "High Diploma" },
  { key: "nan", value: "N/A" },
  { key: "secondary", value: "Secondary" },
  { key: "elementary", value: "Elementary" },
  { key: "primary", value: "Primary" },
  { key: "master", value: "Master" },
  { key: "sec.cert", value: "Secondary Certificate" },
  { key: "diploma", value: "Diploma" },
  { key: "illiterate", value: "Illiterate" },
  { key: "phd", value: "PhD" },
  { key: "professor", value: "Professor" },
]

export const productType = [
  {
    key: "قرض سكني شراء من بنوك أخرى",
    value: "قرض سكني شراء من بنوك أخرى",
  },
  {
    key: "قرض شخصي مقابل تحويل راتب",
    value: "قرض شخصي مقابل تحويل راتب",
  },
  { key: "جدولة اولى", value: "جدولة اولى" },
  { key: "قرض سكني شراء سكن", value: "قرض سكني شراء سكن" },
  { key: "قرض سكني -  أفراد", value: "قرض سكني -  أفراد" },
  { key: "قرض سكني سكن كريم", value: "قرض سكني سكن كريم" },
  {
    key: "قرض شخصي بضمان رهن عقاري",
    value: "قرض شخصي بضمان رهن عقاري",
  },
  {
    key: "قرض سكني موظفين - بفائدة تجارية",
    value: "قرض سكني موظفين - بفائدة تجارية",
  },
  { key: "قروض اخرى- أفراد", value: "قروض اخرى- أفراد" },
  {
    key: "قرض شخصي مقابل تامينات نقدية",
    value: "قرض شخصي مقابل تامينات نقدية",
  },
  { key: "قرض سكني موظفين", value: "قرض سكني موظفين" },
  { key: "قرض شخصي - أفراد", value: "قرض شخصي - أفراد" },
  { key: "قرض شخصي - موظفين", value: "قرض شخصي - موظفين" },
  { key: "قرض عائلتي", value: "قرض عائلتي" },
  { key: "flat قرض سيارة جديدة", value: "flat قرض سيارة جديدة" },
  { key: "قرض سكني بناء سكن", value: "قرض سكني بناء سكن" },
  {
    key: "قرض تنفيذين-مهنيين افراد",
    value: "قرض تنفيذين-مهنيين افراد",
  },
  { key: "flat قرض سيارة مستعملة", value: "flat قرض سيارة مستعملة" },
  { key: "قرض المستهلك", value: "قرض المستهلك" },
  { key: "قرض مخصوم", value: "قرض مخصوم" },
  { key: "قرض سلع معمرة", value: "قرض سلع معمرة" },
  { key: "قرض شراء سيارة جديدة", value: "قرض شراء سيارة جديدة" },
  { key: "قرض سكني موظفين/قديم", value: "قرض سكني موظفين/قديم" },
  { key: "قرض شراء سيارة مستعملة", value: "قرض شراء سيارة مستعملة" },
  { key: "قرض شراء أراضي", value: "قرض شراء أراضي" },
  { key: "قرض التوفير الفوري", value: "قرض التوفير الفوري" },
  {
    key: "قرض شراء سيارة - موظفين",
    value: "قرض شراء سيارة - موظفين",
  },
  { key: "قرض سكني توسعة", value: "قرض سكني توسعة" },
  { key: "قرض الأطباء", value: "قرض الأطباء" },
  {
    key: "قرض شخصي - موظفين بنوك أخرى",
    value: "قرض شخصي - موظفين بنوك أخرى",
  },
  { key: "قرض اطباء الاختصاص", value: "قرض اطباء الاختصاص" },
  {
    key: "قرض سكني مدعوم حكوميا",
    value: "قرض سكني مدعوم حكوميا",
  },
  { key: "قرض شخصي - موظفين/قديم", value: "قرض شخصي - موظفين/قديم" },
  {
    key: "قرض صديق البيئة- افراد",
    value: "قرض صديق البيئة- افراد",
  },
  {
    key: "قرض شراء سيارة - أفراد",
    value: "قرض شراء سيارة - أفراد",
  },
  { key: "قرض سكني - صيانة", value: "قرض سكني - صيانة" },
]

export const productTypeEN = [
  "Personal loan against salary transfer",
  "flat new car loan",
  "My family loan",
  "Housing loan to buy a house",
  "Other loans - individuals",
  "Personal loan against cash deposits",
  "Housing loan to build housing",
  "Loan for individual executives and professionals",
  "Land purchase loan",
  "Personal loan secured by a mortgage",
  "Housing loan purchase from other banks",
  "Consumer Loan",
  "Loan to purchase a new car",
  "First schedule",
  "Used car purchase loan",
  "Durable goods loan",
  "flat used car loan",
  "Governmentally supported housing loan",
  "Environmentally friendly loan - individuals",
  "Personal Loan - Employees",
]

export const employmentLevels = [
  { key: "manager", value: "Manager" },
  { key: "nan", value: "N/A" },
  { key: "other", value: "Other" },
  { key: "lieut.2nd", value: "Lieutenant 2nd" },
  { key: "captain", value: "Captain" },
  { key: "employee", value: "Employee" },
  { key: "sargent", value: "Sergeant" },
  { key: "teacher", value: "Teacher" },
  { key: "gen.mgr", value: "General Manager" },
  { key: "asst.mgr", value: "Assistant Manager" },
  { key: "sec.head", value: "Section Head" },
  { key: "lance.corp", value: "Lance Corporal" },
  { key: "driver", value: "Driver" },
  { key: "admin.spec", value: "Administrative Specialist" },
  { key: "soldier", value: "Soldier" },
  { key: "sarg.1st", value: "Sergeant 1st Class" },
  { key: "admin.emp", value: "Administrative Employee" },
  { key: "office.mgr", value: "Office Manager" },
  { key: "supervisor", value: "Supervisor" },
  { key: "worker", value: "Worker" },
  { key: "police", value: "Police Officer" },
  { key: "nurs.asst", value: "Nursing Assistant" },
  { key: "guard", value: "Guard" },
  { key: "corporal", value: "Corporal" },
  { key: "military", value: "Military" },
  { key: "gm", value: "General Manager" },
  { key: "exec.mgr", value: "Executive Manager" },
  { key: "sec.super", value: "Section Supervisor" },
  { key: "mgr.asst", value: "Manager Assistant" },
  { key: "lieut.1st", value: "Lieutenant 1st" },
  { key: "tea.boy", value: "Tea Boy" },
  { key: "private", value: "Private" },
  { key: "asst.offr", value: "Assistant Officer" },
  { key: "admin.mgr", value: "Administrative Manager" },
  { key: "self.empl", value: "Self-Employed" },
  { key: "ceo", value: "CEO" },
  { key: "sold.1st", value: "Sergeant 1st Class" },
  { key: "lieutenant", value: "Lieutenant" },
  { key: "first.off", value: "First Officer" },
  { key: "lan.cor1st", value: "Lance Corporal 1st" },
]
export const CHANGE_PASSWORD_PERMISSION = "change_password"
